module.exports = __webpack_public_path__ + "img/26-3500-nav.6aa66e51.png";